import { FunctionComponent, PropsWithChildren } from 'react'
import { LoadingButton } from '@mui/lab'
import DownloadIcon from '@mui/icons-material/Download'

type Props = {
    downloading?: boolean
    disabled?: boolean
    onClick?: React.MouseEventHandler<HTMLButtonElement>
    variant?: 'text' | 'outlined' | 'contained'
}

const DownloadButton: FunctionComponent<PropsWithChildren<Props>> = (props) => {
    return (
        <LoadingButton
            loading={props.downloading}
            disabled={props.disabled || props.downloading}
            startIcon={<DownloadIcon />}
            size="small"
            variant={props.variant ?? 'contained'}
            onClick={props.onClick}
        >
            {props.children ?? 'Download'}
        </LoadingButton>
    )
}

export default DownloadButton
